import api from '../services/config/api';

export interface IGetClientsResponse {
  id: number;
  name: string;
}
export const getAllClients = (query: string) =>
  api.get<IGetClientsResponse[]>(`/client/all${query[0] === '?' || !query ? query : `?${query}`}`);
